"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignRequests = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const uuid_1 = require("uuid");
const authored_evidence_1 = require("../../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../../composite/evidence/evidence");
const requests_fields_1 = require("./requests-fields");
const requests_columns_1 = require("./requests-columns");
const signing_types_1 = require("../signing-types");
const requests_detail_toolbar_1 = require("./requests-detail-toolbar");
const signing_context_1 = require("../signing-context");
function SignRequests() {
    const intl = react_intl_1.useIntl();
    const { url, reportTag } = react_1.useContext(signing_context_1.SigningContext);
    const evidence = authored_evidence_1.useAuthoredEvidence({
        identifier: 'EAS_SIGNING_REQUEST',
        apiProps: {
            url,
        },
        tableProps: {
            columns: requests_columns_1.useColumns(),
            tableName: intl.formatMessage({
                id: 'EAS_SIGNING_REQUEST_TABLE_TITLE',
                defaultMessage: 'Dokumenty k podepsání',
            }),
            reportTag,
        },
        detailProps: {
            toolbarProps: {
                after: react_1.default.createElement(requests_detail_toolbar_1.SignRequestToolbar, null),
            },
            FieldsComponent: requests_fields_1.RequestsFields,
            initNewItem: () => ({
                id: uuid_1.v4(),
                state: signing_types_1.SignRequestState.NEW,
            }),
        },
    });
    return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
}
exports.SignRequests = SignRequests;
//# sourceMappingURL=requests.js.map